module.exports = __webpack_public_path__ + "static/img/103082.a0cd6df5.png";